/**
 * Basis-Options-Service für Feldkonfigurationen
 * Die App erweitert diese Klasse und registriert konkrete Options.
 */

import { Injectable } from '@angular/core';
import { IOptionService } from '../../core/interfaces';
import { FieldOption } from '../../core/types';
import { kd } from '../../core/utils';

@Injectable()
export abstract class BaseOptionService implements IOptionService {
	protected options_ = new Map<string, FieldOption>();

	/**
	 * Registriert eine Option für einen Feldnamen
	 */
	registerOption(key: string, opt: Partial<FieldOption>): void {
		const existing = this.options_.get(key);
		const result = existing ? { ...existing, ...opt } : opt;
		this.options_.set(key, result as FieldOption);
	}

	/**
	 * Registriert dieselbe Option für mehrere Feldnamen
	 */
	registerOptionFor(keys: string[], opt: Partial<FieldOption>): void {
		keys.forEach(key => this.registerOption(key, opt));
	}

	/**
	 * Gibt die Konfiguration für ein Feld zurück
	 */
	option(key: string): FieldOption | undefined {
		return this.options_.get(kd(key).key);
	}
}
